var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-order" },
    [
      _c("div", { staticClass: "search-area" }, [
        _c(
          "div",
          { staticClass: "search-content" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "选择订单类型", clearable: "" },
                        model: {
                          value: _vm.searchForm.orderSaleType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderSaleType", $$v)
                          },
                          expression: "searchForm.orderSaleType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "堂食", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "自取", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "打包", value: "3" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "外卖", value: "4" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "订单状态", clearable: "" },
                        model: {
                          value: _vm.searchForm.orderStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderStatus", $$v)
                          },
                          expression: "searchForm.orderStatus",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "未确认", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已确认", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已取消", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "无效", value: "3" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "退货", value: "4" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已分单", value: "5" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "部分分单", value: "6" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已完结", value: "7" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "配送状态", clearable: "" },
                        model: {
                          value: _vm.searchForm.shippingStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "shippingStatus", $$v)
                          },
                          expression: "searchForm.shippingStatus",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "未发货", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已发货", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已收货", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "备货中", value: "3" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已发货(部分商品)", value: "4" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "发货中(处理分单)", value: "5" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已选仓", value: "6" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "支付状态", clearable: "" },
                        model: {
                          value: _vm.searchForm.payStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "payStatus", $$v)
                          },
                          expression: "searchForm.payStatus",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "未付款", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "付款中", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "已付款", value: "2" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入订单号", clearable: "" },
                      model: {
                        value: _vm.searchForm.orderSn,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orderSn", $$v)
                        },
                        expression: "searchForm.orderSn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "团购类型", clearable: "" },
                        model: {
                          value: _vm.searchForm.groupType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "groupType", $$v)
                          },
                          expression: "searchForm.groupType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "报名团", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "直接团", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "拼单", value: "7" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "拼桌", value: "8" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "大单", value: "9" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "action-buttons" },
          [
            _c(
              "el-button",
              { attrs: { type: "warning" }, on: { click: _vm.handleExport } },
              [_vm._v("下载清单")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "orderSn",
              label: "订单号",
              align: "center",
              width: "180",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "addTime",
              label: "下单时间",
              align: "center",
              width: "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatTime(scope.row.addTime)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "payTime",
              label: "付款时间",
              align: "center",
              width: "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatTime(scope.row.payTime)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "consignee",
              label: "收货人",
              align: "center",
              "min-width": "140",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.consignee))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { color: "#999", "font-size": "12px" } },
                      [_vm._v(_vm._s(scope.row.mobile))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "address",
              label: "收货地址",
              align: "center",
              "min-width": "230",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(_vm.getAddress(scope.row)))]),
                    _vm._v(" "),
                    _vm.hasLatLng(scope.row)
                      ? _c(
                          "div",
                          {
                            staticStyle: { color: "#999", "font-size": "12px" },
                          },
                          [
                            _vm._v(
                              "经纬度: " + _vm._s(_vm.getLatLng(scope.row))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderSaleType",
              label: "订单类型",
              align: "center",
              width: "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getOrderSaleTypeText(scope.row.orderSaleType)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "invoiceAmount",
              label: "订单金额",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" +
                        _vm._s(scope.row.invoiceAmount) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "payBenBalance",
              label: "本金支付",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" +
                        _vm._s(scope.row.payBenBalance) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "payGiveBalance",
              label: "赠金支付",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        ¥" +
                        _vm._s(scope.row.payGiveBalance) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "orderStatus",
              label: "订单状态",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getOrderStatusText(scope.row.orderStatus)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "shippingStatus",
              label: "配送状态",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getShippingStatusText(scope.row.shippingStatus)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "payStatus",
              label: "支付状态",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getPayStatusText(scope.row.payStatus)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "invoiceStatus",
              label: "发票状态",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getInvoiceStatusText(scope.row.invoiceStatus)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "操作",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          查看详情\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }